const firebaseConfig = {
    apiKey: "AIzaSyBxK4hjRWKUNrs12zOWM6x9n0RX23QLV7Q",
    authDomain: "autocare-f9536.firebaseapp.com",
    projectId: "autocare-f9536",
    storageBucket: "autocare-f9536.appspot.com",
    messagingSenderId: "274440610878",
    appId: "1:274440610878:web:c86bebf88a978b470f5d6f"
  };

  export default firebaseConfig